module.exports = __webpack_public_path__ + "media/images/dividend/il-coupontheme-thanksgiving-aab00e80a5f330ad3a2b1856414cb537.svg";